import { useMemo } from 'react';
import { useFeatureFlags } from 'components/FeatureFlags';
import { SectionViewOptions } from '../selectors';

/** Flag-driven options for `buildSectionView` and the helpers that share its read order. */
const useSectionViewOptions = (): SectionViewOptions => {
  const { isFeatureEnabled } = useFeatureFlags();
  const sectionEditorSync = isFeatureEnabled('section-editor-sync');
  return useMemo(
    () => ({
      readSectionEditor: sectionEditorSync,
      readSectionModel: sectionEditorSync,
    }),
    [sectionEditorSync]
  );
};

export default useSectionViewOptions;
